import environment from "@environment";
import InstallerService from "./services/installers/installers.service";

export const installerService = new InstallerService(environment.urls.installersApi);
